export default "__VITE_ASSET__DhPZ0h9f__"